.inputContainer {
  display: flex;
  align-items: center;
  gap: var(--gap-regular);
}

.treeItemInput {
  &.selected {
    border-color: var(--color-white);
  }
}
